module.exports = __webpack_public_path__ + "static/media/05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_06.5e7c3f04.jpg";